import React from "react";
import "./Policy.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const AntiCorruption = () => {
  return (
    <>
      <Header />
      <div className="policy-container">
        <div className="policy-content">
          <h2>Política de Anticorrupção</h2>
          <p className="paragrafo">
            <b>Objetivo:</b> Estabelecer as diretrizes para a atuação e conduta
            dos Empregados, Administradores e Terceiros perante órgãos públicos
            nacionais e internacionais na condução de seus trabalhos.
          </p>
          <h4 className="subtitulo">1. INTRODUÇÃO</h4>
          <p className="paragrafo">
            Na JTD TRANSPORTES LTDA, devemos sempre agir com integridade
            profissional e demonstrar o nosso compromisso com as mais elevadas
            normas éticas.
            <br />
            <br />
            Esta Política dá cumprimento à Lei n.º 12.846/2013 e ao Decreto
            Federal n.º 8.420/2015, conforme texto em vigor na data de emissão
            desta Política. Além disso, esta Política leva em consideração a
            melhoria contínua de práticas de governança. Com isso, busca-se
            constantemente garantir os mais elevados padrões de integridade,
            alinhados à transparência nos processos e à sustentabilidade dos
            negócios.
          </p>
          <h4 className="subtitulo">2. ABRANGÊNCIA</h4>
          <p className="paragrafo">
            Esta política aplica-se a todos os Empregados, Administradores e
            Terceiros da JTD TRANSPORTES LTDA.
            <br />
            <br />
            Todos os Empregados, Administradores e Terceiros abrangidos pela
            presente Política, são responsáveis por compreender e cumprir esta
            Política em todos os momentos. Esta Política encontra-se disponível
            no DEPARTAMENTO ADMINISTRATIVO e deverá ser divulgada a todas as
            pessoas que devem cumpri-la.
          </p>
          <h4 className="subtitulo">3. DEFINIÇÕES</h4>
          <h4 className="subtitulo">
            3.1 Os principais termos citados nesta política corporativa incluem:
          </h4>
          <ol className="lista">
            <li>
              a) Administradores: diretores, conselheiros e membros de comitês.
            </li>
            <li>
              b) Autoridade do Governo: todo aquele que exerce uma função
              pública, de forma temporária ou permanente, com ou sem
              remuneração, independentemente do cargo ou do vínculo
              estabelecido. Inclui, mas sem se limitar: (i) qualquer indivíduo
              que atue no Poder Executivo, Legislativo, Judiciário ou no
              Ministério Público Estadual ou Federal;
              <br />
              (ii) qualquer indivíduo que atue em empresas públicas, sociedades
              de economia mista, autarquias ou fundações públicas;
              <br /> (iii) qualquer indivíduo que atue em concessionária de
              serviços públicos, tais como empresas de distribuição de energia
              elétrica ou qualquer instituição de ensino ou saúde;
              <br /> (iv) qualquer candidato a cargo público ou qualquer membro
              de um partido político;
              <br /> (v) qualquer indivíduo que atue em representações
              diplomáticas ou em entidades estatais de país estrangeiro, bem
              como atue em qualquer empresa que seja controlada pelo poder
              público de um país estrangeiro; e <br />
              (vi) todo indivíduo que atue em organizações públicas
              internacionais, tais como a Organização das Nações Unidas ou a
              Organização Mundial do Comércio.
            </li>
            <li>
              {" "}
              c) Código de Conduta: é o Código de Conduta da JTD TRANSPORTES,
              que se encontra disponível no DEPARTAMENTO ADMINISTRATIVO
              fisicamente, em sua sede e filiais.
            </li>
            <li>
              d) Correlatos a Autoridade do Governo: pessoas próximas, amigos,
              cônjuge ou outro membro da família de uma Autoridade do Governo,
              obtendo benefício dessa condição.
            </li>
            <li>
              e) Empregados: empregados devidamente contratados e registrados de
              acordo com as leis trabalhistas aplicáveis.
            </li>
            <li>
              f) Terceiros: qualquer pessoa, física ou jurídica, contratada pela
              JTD TRANSPORTES, e que tenha ou espera- se que venha a ter
              qualquer tipo de contato com qualquer Autoridade do Governo.
              Assim, por exemplo, são considerados Terceiros para fins desta
              Política: representantes comerciais, despachantes, consultores,
              advogados, distribuidores, revendedores, corretores, despachantes
              alfandegários, prestadoras de serviços, embarcadores,
              fornecedores.
            </li>
            <li>
              g) Valor Nominal: o valor é pequeno o suficiente, seja em termos
              monetários, seja em termos de frequência, para não ser visto como
              algo que possa influenciar ou tenha influenciado de forma
              inadequada o julgamento ou as decisões de quem o recebeu.
            </li>
          </ol>
          <h4 className="subtitulo">4. DIRETRIZES</h4>
          <h4 className="subtitulo">4.1 Orientação Geral</h4>
          <p className="paragrafo">
            Os Empregados, Administradores e Terceiros nunca devem oferecer nem
            conceder, a qualquer Autoridade do Governo ou Correlato a Autoridade
            do Governo, qualquer vantagem, monetária ou não, com o objetivo de
            influenciar as decisões que afetem os negócios da JTD TRANSPORTES;
            ou um ganho pessoal que possa causar algum impacto nos interesses
            empresariais da JTD TRANSPORTES; ou para obter informações
            confidenciais sobre oportunidades de negócios, licitações ou as
            atividades de seus concorrentes.
            <br />
            <br />
            Os Empregados, Administradores e Terceiros devem evitar qualquer
            conduta que possa ter aparência de improbidade.
          </p>
          <h4 className="subtitulo">4.2 Dar e Receber Brindes e Presentes</h4>
          <p className="paragrafo">
            Nenhum brinde ou presente poderá ser oferecido, prometido, dado ou
            recebido, direta ou indiretamente, a qualquer Autoridade do Governo
            ou Correlato a Autoridade do Governo, com o objetivo de influenciar
            as decisões da Autoridade do Governo. <br />
            <br />
            Quando for apropriado o uso de brindes e presentes, a JTD
            TRANSPORTES somente poderá oferecer brindes institucionais, assim
            considerados aqueles que exibam logotipos e/ou produtos da empresa,
            e que sejam de Valor Nominal. <br />
            <br />
            Todos os Empregados, Administradores e Terceiros estão
            terminantemente proibidos de, direta ou indiretamente, prometer,
            oferecer ou dar brindes e presentes que não sejam brindes
            institucionais a Autoridades do Governo ou Correlatos a Autoridade
            do Governo. <br />
            <br />
            Todos os registros (inclusive relatórios de despesas) relativos a
            brindes e presentes deverão ser completos e corretos. Apresentar
            informação falsa ou enganosa, ou negligenciar informações
            conscientemente pode ensejar ações disciplinares contra os
            Empregados e Terceiros envolvidos, inclusive sua rescisão
            contratual, conforme Código de Conduta, sem prejuízo de comunicação
            às autoridades competentes nos casos aplicáveis.
          </p>
          <h4 className="subtitulo">
            4.3 Entretenimento e Benefícios de Hospitalidade
          </h4>
          <p className="paragrafo">
            Todos os Empregados, Administradores e Terceiros estão
            terminantemente proibidos de, direta ou indiretamente, prometer,
            oferecer ou prestar qualquer tipo de entretenimento ou benefício de
            hospitalidade às Autoridades do Governo e Correlatos a Autoridades
            do Governo.
          </p>
          <h4 className="subtitulo">
            4.4 Pagamentos Facilitadores/Taxas de Urgência
          </h4>
          <p className="paragrafo">
            Nas circunstâncias em que os pagamentos facilitadores ou taxas de
            urgência forem ilegais, isto é, com o intuito de agilizar ou
            garantir a realização de ações de rotina, tais pagamentos ficam
            estritamente proibidos. Nas circunstâncias, em que os pagamentos
            facilitadores ou as taxas de urgência forem legais, ainda assim,
            sugere-se evitar ao máximo referidos pagamentos.
          </p>
          <h4 className="subtitulo">4.5 Doações e Contribuições Políticas</h4>
          <p className="paragrafo">
            Doações e contribuições políticas em nome da JTD TRANSPORTES são
            proibidas, nos termos do Código de Conduta. Os Empregados,
            Administradores e Terceiros devem evitar qualquer conduta que possa
            ter uma aparência de doação ou contribuição política em nome da JTD
            TRANSPORTES.
          </p>
          <h4 className="subtitulo">
            4.6 Responsabilidade Social, Contribuições Sociais e Patrocínios
          </h4>
          <p className="paragrafo">
            Caso os Empregados, Administradores e Terceiros pretendam praticar
            tais iniciativas, em nome da JTD TRANSPORTES, deverão coordenar as
            ações em conjunto em harmonia com as normas de conduta da JTD
            TRANSPORTES, bem como, empregando transparência e cumprimento dos
            requisitos legais aplicáveis. <br />
            <br />
            Nenhum Empregado, Administrador ou Terceiro poderá, em nome da JTD
            TRANSPORTES, oferecer, fazer ou comprometer-se com alguma
            contribuição ou doação ou projeto de responsabilidade social em
            troca de algum benefício relacionado aos interesses negociais da JTD
            TRANSPORTES e aos interesses individuais de quaisquer Empregados,
            Administradores e Terceiros associados à JTD TRANSPORTES. <br />{" "}
            <br />
            Para garantir que essas operações não facilitem a lavagem de
            dinheiro ou qualquer outro tipo de atividade ilegal, a JTD
            TRANSPORTES previamente deverá conduzir a devida investigação a
            respeito da identidade e reputação da organização ou da pessoa, a
            identidade dos principais participantes, a natureza das atividades
            da organização e suas ligações com outras entidades. <br />
            <br />
            Todos os registros relativos a doações e contribuições sociais
            deverão ser completos e corretos, com a verificação e a comprovação
            que as doações e contribuições foram destinadas e utilizadas para as
            finalidades a que originalmente se destinavam. <br />
            <br />
            Os patrocínios estarão limitados a eventos comerciais legítimos
            alinhados com as atividades e negócios conduzidos pela JTD
            TRANSPORTES e/ou aos casos em que reste comprovado algum tipo de
            benefício à coletividade, como, por exemplo, ações de apoio
            cultural, educacional, assistencial, esportivo, dentre outros. Os
            patrocínios deverão ter caráter oneroso, devendo ficar clara a
            contrapartida a ser recebida pela JTD TRANSPORTES. Os patrocínios
            envolvendo fundações ou quaisquer entidades ligadas a pessoas que
            sejam ou tenham sido a qualquer tempo Autoridades do Governo ou
            Correlatos a Autoridades do Governo deverão ser avaliados e
            aprovados pelo diretor responsável pela área financeira.
            <br />
            <br />
          </p>
          <h4 className="subtitulo">4.7 Participação em Licitações</h4>
          <p className="paragrafo">
            A licitação é o procedimento utilizado pelos órgãos da administração
            direta, os fundos especiais, as autarquias, as fundações públicas,
            as empresas públicas, as sociedades de economia mista e demais
            entidades controladas direta ou indiretamente pela União, Estados,
            Distrito Federal e Municípios para contratação de serviços ou
            produtos de terceiros. <br />
            <br />
            As licitações têm como principal objetivo garantir a isonomia,
            impessoalidade, moralidade, igualdade e publicidade na seleção da
            proposta mais vantajosa para a Administração Pública e devem ser
            realizadas em estrita conformidade com a legislação aplicável.{" "}
            <br />
            <br />
            Os Empregados, Administradores e Terceiros devem sempre agir de modo
            transparente e honesto em relação a todos e quaisquer processos ou
            procedimentos que envolvam licitações ou contratações com a
            administração pública, seja em âmbito nacional ou internacional,
            ficando terminantemente proibidas todas as ações que possam ser
            caracterizadas como fraude em concorrência pública ou manipulação de
            editais de concorrência. <br />
            <br />
            Todas as decisões tomadas no decorrer dos procedimentos licitatórios
            devem ter como fundamento único e exclusivo rígidos padrões
            técnicos, econômicos e jurídicos, e não devem, em nenhuma
            circunstância, se valer do uso indevido de qualquer influência sobre
            a Autoridade do Governo ou sobre concorrentes. <br />
            <br />
            Os Empregados, Administradores e Terceiros podem manter contato com
            a Autoridade do Governo responsável no decorrer da licitação apenas
            e tão somente para esclarecer dúvidas técnicas quanto às regras e
            documentos que devem ser apresentados. Tais contatos devem ser
            formalizados por escrito, seja por carta, e-mail ou qualquer outro
            meio digital.
          </p>
          <h4 className="subtitulo">
            4.8 Outros Tipos de Benefício, incluindo contratação de Empregados
          </h4>
          <p className="paragrafo">
            Praticar o favorecimento (inclusive garantir estágios e empregos a
            Correlatos a Autoridade do Governo; fazer uma contribuição
            beneficente ou de outra natureza com relação às atividades da JTD
            TRANSPORTES; emprestar um produto ou fornecer acesso às instalações
            da JTD TRANSPORTES) deve ser considerado como ato sujeito às leis
            anticorrupção. Segundo essas leis, a forma de “suborno” inclui
            “qualquer coisa de valor” – ou seja, favores, empregos,
            conveniências, doações sociais ou oportunidades favoráveis
            proporcionadas direta ou indiretamente aos contatos comerciais e
            pessoas que possam causar impacto nos negócios da JTD TRANSPORTES.{" "}
            <br />
            <br />
            Com relação a contratação de estagiário ou empregados correlatos a
            autoridades do governo, é de responsabilidade do Recursos Humanos na
            JTD TRANSPORTES, verificar se o candidato é ou já foi Autoridades do
            Governo, bem como se há relação de parentesco deste com as
            Autoridades do Governo. O resultado da pesquisa deverá ser reportado
            ao responsável pela área Jurídica, que fará a recomendação
            pertinente. <br />
            <br />
            Com relação a outros benefícios acima descritos, os Empregados,
            Administradores e Terceiros devem reconhecer e abordar essas
            situações com grande cautela e contatar seu Diretor, o Departamento
            Jurídico ou a Área Jurídica antes de oferecer ou proporcionar esses
            tipos de benefícios a qualquer Autoridade do Governo ou Correlatos a
            Autoridades do Governo.
          </p>
          <h4 className="subtitulo">
            4.9 Procedimentos de Fusões e Aquisições
          </h4>
          <p className="paragrafo">
            A JTD TRANSPORTES deverá adotar procedimento de diligência prévia à
            consumação de operações de compra de ativos ou sociedades, com o
            objetivo de analisar o envolvimento da empresa target em atos de
            corrupção e/ou outras violações legais, bem como a adoção de
            Programa de Integridade para mitigar a ocorrência destes eventos.
          </p>
          <h4 className="subtitulo">4.10 Outras Condutas Proibidas</h4>
          <h4 className="subtitulo">
            4.10.1 Condutas adicionais estritamente proibidas:
          </h4>
          <p className="paragrafo">
            i. Qualquer forma de corrupção, extorsão ou fraude; <br />
            ii. Oferecer ou aceitar propinas, subornos ou outros incentivos
            ilícitos; <br />
            iii. Falsificação de documentos, relatórios de despesas, registros
            financeiros, marcas ou produtos; <br />
            iv. Apropriação indébita, contrabando, falsificação, espionagem
            empresarial ou outras práticas desleais e anticoncorrenciais. <br />
            O rol acima é meramente exemplificativo e não exaustivo. São
            proibidas quaisquer condutas ilegais ou imorais. <br />
          </p>
          <h4 className="subtitulo">4.11 Controles Contábeis</h4>
          <p className="paragrafo">
            A JTD TRANSPORTES mantem um sistema de controle contábil interno que
            requer que todos os Empregados e Administradores façam e mantenham
            registros detalhados de maneira fidedigna e que reflitam fielmente
            as operações e a disposição dos ativos da empresa. <br />
            <br />
            Lançamentos falsos, enganosos ou incompletos em tais registros ou em
            outros documentos são estritamente proibidos. Não poderão ser
            estabelecidos fundos ou contas que não estejam divulgados ou
            registrados, qualquer que seja o motivo. <br />
            <br />
            Os ativos fixos da JTD TRANSPORTES devem ser confrontados
            regularmente com os ativos contábeis. <br /> <br />
            As despesas em que os Empregados, Administradores e Terceiros da JTD
            TRANSPORTES incorrerem deverão ser comprovadas por meio de descrição
            detalhada de atividades e por notas fiscais ou faturas originais que
            reflitam os valores despendidos. <br />
            <br />
            Tanto a apresentação quanto a aceitação consciente de registros,
            notas fiscais, recibos e/ou faturas falsas são estritamente
            proibidas e ficarão sujeitas à sanção, inclusive a rescisão
            contratual e o ajuizamento de ação judicial contra a(s) pessoa(s)
            envolvida(s). <br />
            <br />
          </p>
          <h4 className="subtitulo">4.12 Terceiros</h4>
          <p className="paragrafo">
            A JTD TRANSPORTES conduz suas atividades segundo os mais altos
            padrões de ética e integridade e fazem negócios somente com
            Terceiros íntegros, honestos e qualificados. <br />
            <br />
            A JTD TRANSPORTES deve sempre proceder à devida due diligence do
            Terceiro, antes de contratá-lo, bem como devem fazer o monitoramento
            de suas atividades posteriormente. <br />
            <br />
            A JTD TRANSPORTES não deve contratar Terceiros que foram indicados
            ou recomendados por Autoridades do Governo ou correlatos a
            Autoridades do Governo. Dúvidas devem ser encaminhadas à área
            Jurídica. <br />
            <br />
            Para fins de efetividade desta política perante Terceiros, os
            contratos firmados pela JTD TRANSPORTES deverão conter uma cláusula
            específica referente ao cumprimento das normas anticorrupção,
            mitigando, assim, os riscos da prática de atos corruptos pelos
            Terceiros que agem em nome da JTD TRANSPORTES. <br />
            <br />
            Além disso, os Terceiros deverão prestar declaração confirmando que
            receberam, leram, compreenderam e se comprometem a cumprir com esta
            Política.
          </p>
          <h4 className="subtitulo">4.13 Violação da Lei ou da Política</h4>
          <h4 className="subtitulo">4.13.1 Violações</h4>
          <p className="paragrafo">
            As violações desta política serão investigadas e avaliadas pelo
            Comitê de Conduta da JTD TRANSPORTES, conforme cada caso, podendo
            resultar em sanções para os envolvidos, sem prejuízo de eventual
            comunicação às autoridades competentes se for o caso. <br />
            <br />
            As sanções para as pessoas físicas podem incluir ações
            disciplinares, inclusive, mas sem se limitar, a demissão por justa
            causa, rescisão contratual, sem prejuízo de outras sanções.
          </p>
          <h4 className="subtitulo">4.13.2 Dever de Comunicar</h4>
          <p className="paragrafo">
            Qualquer Empregado, Administrador ou Terceiro que souber ou
            suspeitar da ocorrência real ou iminente de alguma violação desta
            Política deverá encaminhar o caso preferencialmente através da Linha
            Ética ou entrar em contato com o Gerente, ou Diretor da sua área
            e/ou com o Departamento Jurídico. A JTD TRANSPORTES jamais tolerará
            qualquer ato de retaliação contra a pessoa ou empresa que comunicar,
            de boa fé, suspeitas de violações da lei, ética ou de suas
            políticas, garantindo a confidencialidade das informações
            reportadas, bem como o anonimato das pessoas que os utilizarem, o
            que poderá ser feito por meio de qualquer canal de comunicação da
            Ouvidoria da JTD TRANSPORTES.
          </p>
          <h4 className="subtitulo">4.14 DISPOSIÇÕES GERAIS</h4>
          <p className="paragrafo">
            A JTD TRANSPORTES jamais tolerará qualquer ato de retaliação ou
            penalização contra a pessoa que se recusar a praticar atos
            corruptos, mesmo que isso implique em atrasos ou perda de negócios.{" "}
            <br />
            <br />
            Dúvidas com relação à legislação aplicável ou interpretação desta
            Política devem ser esclarecidas com o Departamento Jurídico da JTD
            TRANSPORTES LTDA. <br />
            <br />
            Casos de não aceitação da cláusula de cumprimento das normas
            anticorrupção prevista por Terceiros deverão ser imediatamente
            encaminhados para a área de para o Departamento Jurídico, quando não
            for possível trocar a contraparte. <br />
            <br />
            Denúncias pertinentes aos temas tratados nesta política deverão ser
            acompanhadas, sempre que possível, por fatos e dados concretos.{" "}
            <br />
            <br />
            Todas as denúncias recebidas pela JTD TRANSPORTES serão tratadas com
            sigilo conforme permitido por lei.
          </p>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default AntiCorruption;
